module.exports = __webpack_public_path__ + "img/6.139e47c9.png";